import { Box } from '@mui/material'
import AgentProfileAvatar from '@/components/Agents/AgentProfileAvatar'
import styles from './MentionSuggestionsPopover.module.scss'

export function MentionSuggestionsUserList({ users, activeIndex, onHighlight, onSelect }) {
  return users.map((user, index) => {
    const active = activeIndex === index
    return (
      <button
        key={user.id}
        type="button"
        role="option"
        aria-selected={active}
        className={`${styles.row} ${active ? styles.rowActive : ''}`}
        onMouseEnter={() => onHighlight(index)}
        onMouseDown={(e) => {
          e.preventDefault()
          onSelect({ id: user.id, kind: 'user', label: user.label })
        }}
      >
        <AgentProfileAvatar name={user.name} size={24} />
        <Box className={styles.rowText}>
          <Box component="span" className={styles.rowPrimary}>
            {user.label}
          </Box>
          <Box component="span" className={styles.rowSecondary}>
            {user.subtitle}
          </Box>
        </Box>
      </button>
    )
  })
}
